module.exports = __webpack_public_path__ + "img/new-previous-btn-g.6a2603aa.svg";